import { getTimestamp, addDays, startOfDay, endOfDay, OwaDate } from 'owa-datetime';
import { DAYS_TO_FETCH_ON_INIT_LOAD } from 'mini-calendar-events-store/lib/utils/eventsStoreConstants';

/**
 * Returns a date range for initial load based on a pivot.
 * @param pivotDate Pivot date to pass
 */
export function getPivotDateRangeForInitialLoad(pivotDate: OwaDate) {
    if (pivotDate) {
        return {
            start: getTimestamp(
                startOfDay(addDays(pivotDate, -DAYS_TO_FETCH_ON_INIT_LOAD / 2 + 1))
            ),
            end: getTimestamp(endOfDay(addDays(pivotDate, DAYS_TO_FETCH_ON_INIT_LOAD / 2))),
        };
    } else {
        return {
            start: null,
            end: null,
        };
    }
}
